import './src/styles/global.css';

import type { GatsbyBrowser } from 'gatsby';
import * as React from 'react';
import type { LayoutProps } from './src/components/Layout/Layout';
import Layout from './src/components/Layout/Layout';

/**
 * Disable Gatsby's automatic scroll restoration. TransitionLayout scrolls to
 * the top itself while the page is faded out, so the jump is never visible.
 * Without this, Gatsby scrolls to top during the exit fade — a visible double jump.
 */
export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = () => false;

/**
 * Wraps every page with the Layout component, providing consistent
 * navigation, footer, and TransitionLayout for GSAP page transitions.
 *
 * Requirements: 6.3, 1.1
 */
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
  return React.createElement(
    Layout,
    {
      pageContext: props.pageContext as LayoutProps['pageContext'],
      location: props.location,
    },
    element,
  );
};
